<template>
  <el-menu-item v-if="!menu.children || menu.children.length === 0" :index="menu.path || uniqueId">
    {{menu.title || '未命名菜单'}}
  </el-menu-item>
  <el-submenu v-else-if="menu.children && menu.path === '/transport'" :index="menu.path || uniqueId" class="hide-arrow">
    <template slot="title">
      {{menu.title || '未命名菜单'}}
  </template>
    <el-menu-item-group title="分类1">
      <template slot="title">
        <img src="../../image/APP-downl.png" alt="图片描述" />
        分类1
      </template>
    <el-menu-item  :index="'/transport/workbench' || uniqueId">
      {{'我的工作台' || '未命名菜单'}}
    </el-menu-item>
      <el-menu-item  :index="'/transport/wayBillInfo/wayBillInfo' || uniqueId">
        {{'运单管理' || '未命名菜单'}}
      </el-menu-item>
    </el-menu-item-group>
    <el-menu-item-group title="分类2">
      <template slot="title">
        <img src="../../image/server-hot.png" alt="图片描述" />
        分类2
      </template>
      <el-menu-item  :index="'/orders/phaseTransportDemand' || uniqueId">
        {{'阶段运输需求' || '未命名菜单'}}
      </el-menu-item>
      <el-menu-item  :index="'/orders/dailyTransportDemand' || uniqueId">
        {{'日运输需求' || '未命名菜单'}}
      </el-menu-item>
      <el-menu-item  :index="'/orders/leagueOfNationsWaybill' || uniqueId">
        {{'国联运单新建' || '未命名菜单'}}
      </el-menu-item>
    </el-menu-item-group>
  </el-submenu>
  <el-submenu v-else :index="menu.path || uniqueId" class="hide-arrow">
    <template slot="title">
      {{menu.title || '未命名菜单'}}
    </template>
      <el-menu-item v-for="(item, menuIndex) in menu.children" :key="menuIndex" :index="item.path || uniqueId">
        {{item.title || '未命名菜单'}}
      </el-menu-item>
  </el-submenu>
</template>

<script>
import { uniqueId } from 'lodash'
export default {
  name: 'header-aside-menu-item',
  props: {
    menu: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  created() {
    console.log(this.menu,'0000000000000')
  }
  ,
  data () {
    return {
      uniqueId: uniqueId('menu-empty-')
    }
  }
}
</script>

<style lang="scss">
.hide-arrow .el-submenu__icon-arrow {
  display: none;
}
body{

}

</style>
